import ClipPill from './clipper'

// Each pill interaction will have a gobal initialization. Depending on the type of
// pill, the initialization can be local too.
// The reason pill interactions are dependent on type of pill is because all the events
// from creation to updation and deletion are dependent on the type.
const clipPill = new ClipPill()

export { clipPill }
